import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { tenantProvisioningService } from '@/services/control/tenant-provisioning-service';
import type { TenantAuthSettings } from '@/types/control/tenant-provisioning';

import { adminQueryKeys } from '@/hooks/admin/query-keys';
import { retryControlApi } from '@/hooks/admin/retry';

/** One tenant's stored auth settings, secret excluded. */
export function useTenantAuth(
  tenantId: string
): UseQueryResult<TenantAuthSettings, Error> {
  return useQuery<TenantAuthSettings, Error>({
    queryKey: adminQueryKeys.tenantAuth(tenantId),
    queryFn: ({ signal }) =>
      tenantProvisioningService.getAuth(tenantId, signal),
    enabled: tenantId !== '',
    retry: retryControlApi,
  });
}
